import React from 'react';
import { constants as stopConstants } from 'utils/dateAndTimes';
import { useTranslation } from 'react-i18next';
import useIsSpainCountry from 'hooks/useIsSpainCountry';
// styles
import styled from 'styled-components';
// components
import {
  CartPackagesIcon,
  ShipmentDownloadIcon,
  ShipmentUploadIcon,
} from 'refactored/ui/icons';

const ColoredText = styled.span`
  color: var(--accent500);
`;

const FlexContainer = styled.div`
  display: flex;
`;

const IconContainer = styled.div`
  margin-right: 10px;
  margin-bottom: 18px;
`;

const HandlingToolTipContent = ({ stopType, className }) => {
  const { t } = useTranslation('HandlingExtra');
  const isSpainCountry = useIsSpainCountry();
  const isPickup = stopType === stopConstants.STOP_TYPES.pickup;

  //   france
  if (!isSpainCountry) return <>{t(`tooltip_${stopType}`)}</>;

  //   spain pickup
  if (isPickup)
    return (
      <div className={className}>
        <FlexContainer>
          <IconContainer>
            <ShipmentUploadIcon />
          </IconContainer>
          <div>{t(`${stopType}_tooltip`)}</div>
        </FlexContainer>
        <FlexContainer>
          <IconContainer>
            <CartPackagesIcon />
          </IconContainer>
          <div>
            {t('extra_hanling_first')}
            <ColoredText> {t('extra_hanling_second')} </ColoredText>
            {t('extra_hanling_therd')}
          </div>
        </FlexContainer>
      </div>
    );

  // spain dropoff
  return (
    <div className={className}>
      <FlexContainer>
        <IconContainer>
          <ShipmentDownloadIcon />
        </IconContainer>
        <div>{t(`${stopType}_tooltip`)}</div>
      </FlexContainer>
      <FlexContainer>
        <IconContainer>
          <CartPackagesIcon />
        </IconContainer>
        <div>
          {t('extra_hanling_first')}
          <ColoredText> {t('extra_hanling_second')} </ColoredText>
          {t('extra_hanling_therd')}
        </div>
      </FlexContainer>
    </div>
  );
};

export default styled(HandlingToolTipContent)``;
